import { API } from 'aws-amplify';

const API_NAME = "CommonAPI";
// const BASE_PATH = "/common"

export default class CommonService {
    async activateProject(queryStringParameters={}, data) {
        return API.post( API_NAME, `/project/activate`, {queryStringParameters:queryStringParameters, body: data } )
    }
}